import React, { Fragment, useContext } from "react";
import Logo from "../../img/tek.png";
import { Link } from "react-router-dom";
import AuthContext from "../../Contexts/Autenticacion/authContext";

const Navbar = () => {
  const { autenticado, cerrarSesion } = useContext(AuthContext);

  const handleSingOut = () => {
    cerrarSesion();
  };

  return (
    <Fragment>
      <nav className="navbar navbar-expand-lg navbar-dark bg-secondary border-bottom border-white shadow">
        <div className="container">
          <Link class="navbar-brand  d-flex align-items-center " to="/">
            <img
              src={Logo}
              width="50"
              height="50"
              class="d-inline-block align-top img-fluid  border "
              alt=""
              loading="lazy"
            />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className=" ml-auto navbar-nav">
              <Link className="nav-item" to="/dashboard">
                <span className="nav-link" href="#!">
                  Dashboard
                </span>
              </Link>
              {!autenticado ? (
                <Fragment>
                  <Link className="nav-item" to="/singin">
                    <span className="nav-link" href="#!">
                      SingIn
                    </span>
                  </Link>
                  <Link className="nav-item" to="/singup">
                    <span className="nav-link" href="#!">
                      SingUp
                    </span>
                  </Link>
                </Fragment>
              ) : null}
              {autenticado ? (
                <button
                  className="nav-item btn btn-secondary"
                  onClick={handleSingOut}
                >
                  SingOut
                </button>
              ) : null}
            </ul>
          </div>
        </div>
      </nav>
    </Fragment>
  );
};

export default Navbar;
